<div class="container">
  <div class="content">
    <ng-container *ngIf="forgotPasswordDiv">
      <div class="app-stateful-back-button">
        <app-stateful-internal-link
          [text]="this.backText"
          [pageUrl]="this.backUrl"
        >
        </app-stateful-internal-link>
      </div>
      <div class="center-column">
        <img class="nowaccount-logo" alt="NowAccount Logo" />
        <h1>{{ this.headerText }}</h1>
        <app-serverside-alert></app-serverside-alert>
        <ng-container [formGroup]="this.form">
          <app-kendo-textbox
            inputText="{{ this.emailText }}"
            formControlName="email"
            inputType="email"
            [parentForm]="form"
          ></app-kendo-textbox>
          <div
            class="parent-invalid-feedback"
            *ngIf="
              this.form.get('email')?.invalid &&
              (this.form.get('email')?.dirty || this.form.get('email')?.touched)
            "
          >
            <div class="invalid-feedback">
              <kendo-formerror
                *ngIf="this.form.get('email')?.errors?.['required']"
                >Email is required.
              </kendo-formerror>
            </div>
          </div>
          <div class="button-wrapper">
            <app-primary-button
              text="{{ this.sendbtnTxt }}"
              href=""
              [clickEvent]="this.resetPassword.bind(this)"
            >
            </app-primary-button>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="forgotPasswordSuccessDiv">
      <div class="app-stateful-back-button">
        <app-stateful-internal-link
          [text]="this.backText"
          [pageUrl]="this.backUrl"
        >
        </app-stateful-internal-link>
      </div>
      <div class="center-column">
        <img class="nowaccount-logo" alt="NowAccount Logo" />
        <span
          class="forgot-password-message"
          [innerHTML]="this.forgetpasswordSuccssesMessage"
        ></span>
      </div>
    </ng-container>

    <ng-container *ngIf="forgotPasswordErrorDiv">
      <div class="app-stateful-back-button">
        <app-stateful-internal-link
          [text]="this.backText"
          [pageUrl]="this.backUrl"
        >
        </app-stateful-internal-link>
      </div>
      <div class="center-column">
        <img class="nowaccount-logo" alt="NowAccount Logo" />
        <span
          class="forgot-password-message"
          [innerHTML]="this.forgetpasswordErrorMessage"
        ></span>
      </div>
    </ng-container>
  </div>
</div>
